module.exports = __webpack_public_path__ + "static/media/IMG_0352.8346440e.JPG";